import React from 'react'
import { Route } from 'react-router-dom'
import ConfirmEmailChange from './ConfirmEmailChange'

const ConfirmEmailChangeRoute = () => (
  <Route
    key="confirm-email"
    path="/confirm-email"
    component={ConfirmEmailChange}
  />
)

export default ConfirmEmailChangeRoute
